module.exports = __webpack_public_path__ + "static/media/auctioneer.c1fec200.mp3";